interface HorizontalMarqueeProps {
  children: React.ReactNode;
}

export const HorizontalMarquee = ({ children }: HorizontalMarqueeProps) => {
  return (
    <div
      style={{ maxWidth: "100vw" }}
      className="relative flex overflow-x-hidden"
    >
      <div className="py-12 animate-marquee-horizontal whitespace-nowrap flex gap-8">
        {children}
      </div>

      <div className="absolute py-12 animate-marquee2-horizontal whitespace-nowrap flex gap-8">
        {children}
      </div>
    </div>
  );
};
